// w1.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W1 = () => {
  return <WW config={pageConfigs.w1} />;
};

export default W1;
